import "./style.scss";
import Activities from "../Activities";
import PageHeader from "../PageHeader";
import Skeleton from "components/BaseWidgets/skeleton";

function RightSection({ data, isLoading, setCurrentPage, setShow }) {
  const activitySections = [
    {
      title: "Today",
      data: data?.activity_today || [],
    },
    {
      title: "Earlier",
      data: data?.activity_earlier || [],
    },
  ].filter((section) => section.data.length > 0);

  return (
    <div className="flex flex-col gap-6 w-full activity-right-section">
      <PageHeader
        setShow={setShow}
        setCurrentPage={setCurrentPage}
        data={activitySections}
      />
      {isLoading ? (
        <Skeleton label={false} height={400} />
      ) : (
        <Activities data={activitySections} />
      )}
    </div>
  );
}

export default RightSection;
